import { create } from 'zustand';

type Asset1003Store = {
  activeForm:
    | { type: 'subordinateFinancing' }
    | { type: 'asset'; assetId: number | null }
    | { type: 'reserves' }
    | null;
};

export const useAsset1003Store = create<Asset1003Store>()(() => ({
  activeForm: null,
}));
